import React from 'react';
import { ActivityIndicator } from '@/components/activity-indicator';
import { createStyles } from '@/contexts/theme-context';
import { StyleProp, Text, View, ViewStyle } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  message: string;
  style?: StyleProp<ViewStyle>;
}

export const ScanResultsLoading: React.FC<Props> = ({ message, style }) => {
  const [styles] = useStyles();
  return (
    <View style={styles.base}>
      <View style={[styles.loadingIndicatorContainer, style]}>
        <ActivityIndicator size="large" testID="scanning-indicator" />
        <Text style={[TYPOGRAPHY.medium, styles.loadingStateText]}>
          {message}
        </Text>
      </View>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    flex: 1,
  },
  loadingIndicatorContainer: {
    flex: 1,
    gap: 12,
    justifyContent: 'center',
  },
  loadingStateText: {
    color: theme.sk.color.text.secondary,
    textAlign: 'center',
  },
}));
